import Api from './api';

const slug = 'v1/sessions';
export default {
  createGroupSession(session) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/group`, session)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  createOneOnOneSession(session) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/one-on-one`, session)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSessions(params) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/`, {params})
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSession(sessionId) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/${sessionId}`, {})
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateSession(session) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/update/${session._id}`, session)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteSession(session) {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}/${session._id}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  addAttendeeToSession(sessionId, userId) {
    return new Promise((resolve, reject) => {
      Api.put(`/${slug}/${sessionId}/attendees/${userId}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  removeAttendeeFromSession(sessionId, userId) {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}/${sessionId}/attendees/${userId}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
};
